function filterThumbnailsBySelectedVariant() {
  const variantSelects = document.querySelector('.product__info-container');

  if (variantSelects) {
    const selectedInput = variantSelects.querySelector('input[type="radio"]:checked');

    if (selectedInput) {
      const rawValue = selectedInput.value;
      const formattedValue = `#color_${rawValue.toLowerCase().replace(/\s+/g, '_')}`;

      const thumbnails = document.querySelectorAll('.thumbnail-list__item');

      thumbnails.forEach((item) => {
        const altValue = item.getAttribute('data-alt');
        // console.log(altValue, formattedValue);
        if (altValue === formattedValue) {
          item.style.display = '';  // Show this thumbnail
        } else {
          item.style.display = 'none';  // Hide others
        }
      });
    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const variantSelects = document.querySelector('.product__info-container');

  if (variantSelects) {
    // Run once on load
    filterThumbnailsBySelectedVariant();

    // Run on click inside the container
    variantSelects.addEventListener('click', filterThumbnailsBySelectedVariant);
  }
});
